import InfoLayout from "./InfoLayout";

function Support() {
    return (
       <InfoLayout title="Contact / Support">
            <div>
                <p><strong>Email:</strong> <a href="mailto:admin@tabataworkout.online">admin@tabataworkout.online</a></p>
                <p><strong>Provider:</strong> <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer">www.tabataworkout.online</a></p>
                
                <hr />

                <p>Do you have an idea on how to improve the Tabata Timer app?  
Are you missing a feature you would like to see? Or have you encountered a bug or another issue?  
We’d love to hear your feedback and suggestions – every comment helps us make the app better and more user-friendly.  
Don’t hesitate to contact us!</p>

            </div>
        </InfoLayout>

    );
}

export default Support;
